import React from 'react';

import CustomInput from 'creative-components/CustomInput/CustomInput';

const CustomInputDashboard = (props) => (
  <CustomInput isDashboard {...props} />
);

export default CustomInputDashboard;
